module.exports = __webpack_public_path__ + "img/Profil_CS-Profiii_UniversalClassic.eb02f7f7.jpg";